export default {
	drawer: {
		imprint: '@:common.imprint',
		termsAndPrivacy: 'Terms {amp} Privacy',
		changelog: 'Change history',
	},
}
